import React, { useEffect } from "react";
import { Pagination } from "../../util/types";
import { useSearchParams } from "react-router-dom";

export function PaginationElement({ pagination }: { pagination: Pagination }) {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "ArrowRight") {
                navigateToNextPage();
            } else if (e.key === "ArrowLeft") {
                navigateToPreviousPage();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination, searchParams, setSearchParams]);

    const navigateToNextPage = () => {
        const next_page_number = pagination.current_page === pagination.total_pages ? pagination.current_page : pagination.current_page + 1;
        const updatedSearchParams = new URLSearchParams(searchParams.toString());
        updatedSearchParams.set('page', next_page_number.toString());
        setSearchParams(updatedSearchParams);
    };

    const navigateToPreviousPage = () => {
        const previous_page_number = pagination.current_page === 1 ? pagination.current_page : pagination.current_page - 1;
        const updatedSearchParams = new URLSearchParams(searchParams.toString());
        updatedSearchParams.set('page', previous_page_number.toString());
        setSearchParams(updatedSearchParams);
    };

    if (pagination.total_pages === 1) {
        return <></>;
    }

    return (
        <nav className="pagination">
            <PreviousLink pagination={pagination} />
            <CurrentPage pagination={pagination} />
            <NextLink pagination={pagination} />
        </nav>
    );
}

function CurrentPage({ pagination }: { pagination: Pagination }) {
    return <span className="current-page">Side {pagination.current_page} af {pagination.total_pages}</span>;
}

function NextLink({ pagination: { current_page, total_pages } }: { pagination: Pagination }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const next_page_number = current_page === total_pages ? current_page : current_page + 1;

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        const updatedSearchParams = new URLSearchParams(searchParams.toString());
        updatedSearchParams.set('page', next_page_number.toString());
        setSearchParams(updatedSearchParams);
    };

    if (next_page_number === current_page) {
        return <span className={'next-page disabled'}>Næste side</span>;
    } else {
        return <button onClick={onClick} className={'next-page enabled'}>Næste side</button>;
    }
}

function PreviousLink({ pagination: { current_page } }: { pagination: Pagination }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const previous_page_number = current_page === 1 ? current_page : current_page - 1;

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        const updatedSearchParams = new URLSearchParams(searchParams.toString());
        updatedSearchParams.set('page', previous_page_number.toString());
        setSearchParams(updatedSearchParams);
    };

    if (previous_page_number === current_page) {
        return <span className={'previous-page disabled'}>Forrige side</span>;
    } else {
        return <button onClick={onClick} className={'previous-page enabled'}>Forrige side</button>;
    }
}
